<template>
  <div class="input-moeda">
    <span class="input-moeda__prefixo">R$</span>
    <input
      :id="id"
      :value="formatado"
      type="text"
      inputmode="numeric"
      class="input-moeda__campo"
      placeholder="0,00"
      @input="onInput"
    />
  </div>
</template>

<script>
// Campo de valor em reais: digita-se só números e os dois últimos viram
// centavos (1234 → 12,34). Emite o valor como número (ou null se vazio).
export default {
  name: "InputMoeda",
  props: {
    modelValue: { type: Number, default: null },
    id: { type: String, default: undefined },
  },
  emits: ["update:modelValue"],
  computed: {
    formatado() {
      return this.modelValue == null ? "" : this.formatar(this.modelValue);
    },
  },
  methods: {
    onInput(event) {
      const digitos = event.target.value.replace(/\D/g, "");
      const valor = digitos ? Number(digitos) / 100 : null;
      this.$emit("update:modelValue", valor);
      // Mantém o campo formatado mesmo quando o valor não muda (ex.: letra)
      event.target.value = valor == null ? "" : this.formatar(valor);
    },
    formatar(valor) {
      return valor.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
.input-moeda {
  display: flex;
  align-items: stretch;
  border: 1.5px solid var(--c-border);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  overflow: hidden;
}

.input-moeda:focus-within {
  border-color: var(--c-accent);
  box-shadow: 0 0 0 3px var(--c-accent-glow);
}

.input-moeda__prefixo {
  display: flex;
  align-items: center;
  padding: 0 0.625rem;
  background: var(--c-bg);
  color: var(--c-text-muted);
  font-size: 0.875rem;
  font-weight: 600;
  border-right: 1px solid var(--c-border-light);
}

.input-moeda__campo {
  flex: 1;
  min-width: 0;
  border: none !important;
  box-shadow: none !important;
  outline: none;
  background: transparent;
}
</style>
